// JS for Plan Addons
import $ from 'jquery'

$(document).on('change', '.product-checkbox', function () {
  var $thischeckbox = $(this);
  var value = $(this).prop('checked') === true ? 'add' : 'remove';
  const product_info = $(this).data('product-info');
  var elipsis = '<span class="ellipsis-anim"><span>.</span><span>.</span><span>.</span></span>';
  var coverage = 0;
  if (value == 'add') {
    $('label[for="' + $thischeckbox.attr('id') + '"]').html('Adding ' + product_info.product_title + elipsis);
    var data = {
      action: 'dg_woocommerce_ajax_add_to_cart',
      product_id: product_info.product_id,
      quantity: 1,
      variation_id: '',
    };
    if (product_info.product_id == EAPLUS_VARS.tiered_product_id) {
      data.devices = $("#tiered_devices_number").val();
      coverage = $("#tiered_devices_number").val();
    }
    $(document.body).trigger('adding_to_cart', [$thischeckbox, data]);
    $.ajax({
      type: 'post',
      url: wc_add_to_cart_params.ajax_url,
      data: data,
      beforeSend: function (response) { },
      complete: function (response) { },
      success: function (response) {
        if (response.in_cart) {
          $('label[for="' + $thischeckbox.attr('id') + '"]').html('Add ' + product_info.product_title);
        }
        if (response.fragments.cart_total) {
          $('.price-total').html(response.fragments.cart_total);
        }
        if (response.cart_total) {
          $('.price-total').html(response.cart_total);
        }
        $('#' + $thischeckbox.attr('id') + '_text').html('Added');
        $('label[for="' + $thischeckbox.attr('id') + '"]').text('Added to cart');
        if (response.error & response.product_url) {
          window.location = response.product_url;
          return;
        } else {
          $(document.body).trigger('added_to_cart', [response.fragments, response.cart_hash, $thischeckbox]);
        }

        var dataLayer = (window.dataLayer = window.dataLayer || []);
        dataLayer.push({
          'event': 'choose_plan',
          'client': EAPLUS_VARS.client_code,
          'tracking_code': EAPLUS_VARS.tracking_code,
          'discount': EAPLUS_VARS.discount,
          'conversion': '',
          'plan': product_info.product_title,
          'coverage': coverage
        });

      },
    });
  } else {
    $('label[for="' + $thischeckbox.attr('id') + '"]').html('Removing ' + product_info.product_title + elipsis);
    var data = {
      action: 'dg_woocommerce_ajax_remove_from_cart',
      product_id: product_info.product_id,
      quantity: 1,
      variation_id: '',
    };
    if (product_info.product_id == EAPLUS_VARS.tiered_product_id) {
      data.devices = $("#tiered_devices_number").val();
    }
    $.ajax({
      type: 'post',
      url: wc_add_to_cart_params.ajax_url,
      data: data,
      beforeSend: function (response) { },
      complete: function (response) { },
      success: function (response) {
        if (response.fragments.cart_total) {
          $('.price-total').html(response.fragments.cart_total);
        }
        if (response.cart_total) {
          $('.price-total').html(response.cart_total);
        }
        $('label[for="' + $thischeckbox.attr('id') + '"]').text('Add ' + product_info.product_title);
        if (response.error & response.product_url) {
          window.location = response.product_url;
          return;
        } else {
          $(document.body).trigger('removed_from_cart', [response.fragments, response.cart_hash, $thischeckbox]);
        }
      },
    });
  }
  // var dataLayer = (window.dataLayer = window.dataLayer || []);
  // dataLayer.push({
  //   'event': 'plan_addon',
  //   'client': '<?php echo \Convertiv\Theme\Helpers\__get_client_code(); ?>',
  //   'tracking_code': '<?php echo \Convertiv\Theme\Helpers\__get_tracking_code(); ?>',
  //   'discount': '<?php echo \Convertiv\Theme\Helpers\__get_discount($order = false); ?>',
  //   'conversion': '',
  //   'addon': product_info.product_title
  // });
});

$(document).on('change', '#tiered_devices_number', function () {
  var $thisselect = $(this);
  var value = $(this).find(":selected").val();
  const product_info = $(this).data('product-info');

  var data = {
    action: 'dg_woocommerce_ajax_update_devices_number',
    product_id: product_info.product_id,
  };

  if (product_info.product_id == EAPLUS_VARS.tiered_product_id) {
    data.devices = value;
  }

  $.ajax({
    type: 'post',
    url: wc_add_to_cart_params.ajax_url,
    data: data,
    beforeSend: function (response) { },
    complete: function (response) { },
    success: function (response) {
      if (response.fragments.cart_total) {
        $('.price-total').html(response.fragments.cart_total);
      }
      if (response.cart_total) {
        $('.price-total').html(response.cart_total);
      }
      //$('#' + $thischeckbox.attr('id') + '_text').html('Added');
      //$('label[for="' + $thischeckbox.attr('id') + '"]').text('Added to cart');
      if (response.error & response.product_url) {
        //window.location = response.product_url;
        //return;
      } else {
        $(document.body).trigger('added_to_cart', [response.fragments, response.cart_hash, $thisselect]);
      }
    },
  });

});

$(document.body).on('added_to_cart removed_from_cart', function (event, fragments, cart_hash) {
  if (fragments) {
    $.each(fragments, function (key) {
      $(key)
        .addClass('updating')
        .fadeTo('400', '0.6')
        .block({
          message: null,
          overlayCSS: {
            opacity: 0.6
          }
        });
    });

    $.each(fragments, function (key, value) {
      $(key).replaceWith(value);
      $(key).stop(true).css('opacity', '1').unblock();
    });

    $(document.body).trigger('wc_fragments_loaded');
  }
});

$(document).on('click', '.btn-sign-up', function (e) {
  e.preventDefault();
  var $thisbutton = $(this);
  const product_info = $(this).data('product-info');
  var elipsis = '<span class="ellipsis-anim"><span>.</span><span>.</span><span>.</span></span>';
  var coverage = 0;
  //$thisbutton.html('Adding ' + product_info.product_title + elipsis);
  $thisbutton.html('Redirecting' + elipsis);
  $('.btn-ssign-up').each(function (i) {
    //$(this).html('Adding ' + product_info.product_title + elipsis);
    $(this).html('Redirecting' + elipsis);
  });
  var data = {
    action: 'dg_woocommerce_ajax_add_to_cart',
    product_id: product_info.product_id,
    quantity: 1,
    variation_id: '',
    single_product: true,
  };
  if (product_info.product_id == EAPLUS_VARS.tiered_product_id) {
    data.devices = $("#tiered_devices_number").val();
    coverage = $("#tiered_devices_number").val();
  }
  $(document.body).trigger('adding_to_cart', [$thisbutton, data]);
  $.ajax({
    type: 'post',
    url: wc_add_to_cart_params.ajax_url,
    data: data,
    beforeSend: function (response) { },
    complete: function (response) { },
    success: function (response) {
      if (response.in_cart) {
        //$('label[for="' + $thisbutton.attr('id') + '"]').html('Add ' + product_info.product_title);
        // $thisbutton.html(product_info.product_title + ' is already in the cart');
        // $('.btn-ssign-up').each(function(i) {
        // 	$(this).html(product_info.product_title + ' is already in the cart');
        // });
        $thisbutton.html('Redirecting' + elipsis);
        $('.btn-ssign-up').each(function (i) {
          $(this).html('Redirecting' + elipsis);
        });
        if (response.success == true && response.redirect_url) {
          console.log('redirecting to ' + response.redirect_url);
          window.location = response.redirect_url;
          return;
        }
      } else {
        //$thisbutton.html('Added to cart');
        $thisbutton.html('Redirecting' + elipsis);
        $('.btn-ssign-up').each(function (i) {
          //$(this).html('Added to cart');
          $(this).html('Redirecting' + elipsis);
        });
        if (response.success == true && response.redirect_url) {
          console.log('redirecting to ' + response.redirect_url);
          window.location = response.redirect_url;
          return;
        }
      }
      if (response.error & response.product_url) {
        window.location = response.product_url;
        return;
      } else {
        $(document.body).trigger('added_to_cart', [response.fragments, response.cart_hash, $thisbutton]);
      }

      var dataLayer = (window.dataLayer = window.dataLayer || []);
      dataLayer.push({
        'event': 'choose_plan',
        'client': EAPLUS_VARS.client_code,
        'tracking_code': EAPLUS_VARS.tracking_code,
        'discount': EAPLUS_VARS.discount,
        'conversion': '',
        'plan': product_info.product_title,
        'coverage': coverage
      });

    },
  });
});
